import { Component, Input, EventEmitter, Output, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';

import { IRowAction, IIdWithTeams, AzavistaSharedService } from '@azavista/components/shared';
import { IIconViewCardData as IIconViewData, IIconViewActionSelectedData } from './interfaces';
import { SharedService } from '../shared.service';

interface ILocalData extends IIconViewData {
    thumbnailSrc: string;
}

@Component({
    selector: 'azavista3-icon-view',
    templateUrl: 'icon-view.component.html',
    standalone: false
})
export class IconViewComponent implements OnChanges, OnDestroy {
    @Input() actions: IRowAction[] = [];
    @Input() cardsData: IIconViewData[] = [];
    @Input() defaultThumbnailUrl = '';
    @Input() teamIds: number[] = [];

    @Output() actionSelected = new EventEmitter<IIconViewActionSelectedData>();

    localData: ILocalData[] = [];
    selectedCard: ILocalData;

    constructor(private sharedSvc: SharedService, private cmpSharedSvc: AzavistaSharedService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.cardsData) {
            this.createEmailTemplatesCardData();
        }
    }

    createEmailTemplatesCardData(): void {
        if (!this.cardsData) {
            this.cardsData = [];
        }
        this.localData = this.cardsData.map(x => ({ id: x.id, name: x.name, preview: x.preview } as ILocalData));
        this.setAllCardsSmallThumbnails(this.localData);
    }

    async setAllCardsSmallThumbnails(emailTemplatesCardData: ILocalData[]): Promise<void> {
        const defaultSrc = this.defaultThumbnailUrl;
        emailTemplatesCardData.forEach(x => x.thumbnailSrc = x.thumbnailSrc || defaultSrc);
        for (const cardData of emailTemplatesCardData) {
            if (cardData.thumbnailSrc === defaultSrc && cardData.preview) {
                cardData.thumbnailSrc = await this.sharedSvc.getPreviewImgSrc(cardData.preview, defaultSrc);
            }
        }
    }

    onCardMenuSelected(localData: ILocalData): void {
        this.selectedCard = localData;
    }

    onCardMenuActionSelected(action: IRowAction): void {
        this.actionSelected.emit({ action: action, card: this.selectedCard });
    }

    getActionMenuItemDisabledState(action: IRowAction): boolean {
        const dummyRowId = 1;
        const selection = new SelectionModel<number>(false, [dummyRowId]);
        const idWithItems = [{ id: dummyRowId, teamIds: this.teamIds }] as IIdWithTeams[];
        const isDisabled = this.cmpSharedSvc.getActionMenuItemDisabledState(
            action, selection, idWithItems, idWithItems
        );
        return isDisabled;
    }

    ngOnDestroy(): void {
        this.sharedSvc.disposePreviewImgResources();
    }
}
